import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
//import logger from 'redux-logger';

//import registerServiceWorker from 'registerServiceWorker';
import "css/index.css";
//https://github.com/HubSpot/pace
import 'pace';
import 'pace/themes/red/pace-theme-flash.css';

import { reducers } from 'store';
import App from './App';

// lazyload
/*require('lazysizes');
document.addEventListener('lazybeforeunveil', function(e){
    const bg = e.target.getAttribute('data-bg');
    if(bg) e.target.style.backgroundImage = 'url(' + bg + ')';
});*/
require('lazysizes');
require('lazysizes/plugins/unveilhooks/ls.unveilhooks.min'); // support for background images

const store = createStore(
    reducers, 
    {}, 
    compose(
        applyMiddleware(reduxThunk), 
        //applyMiddleware(logger)
    )
);

const Router = () => {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </Provider>
    )
}

ReactDOM.render(<Router />, document.getElementById('root'));
//registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js